import {
  bankConnected,
  Button,
  Div,
  H3,
  Img,
  isPartner,
  ModalPortal,
  P,
} from '@vgrubs/components';

export const BankConnected = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <ModalPortal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      width="400px"
    >
      <Div $flex $center $mb="24">
        <Img alt="" src={bankConnected} $width="250px" $widthSM="200px" />
      </Div>

      <H3 $mb="12" $center>
        Bank Connected
      </H3>

      <P $center $mb="40">
        {isPartner ? 'Your account' : 'This account'} is securely linked.{' '}
        {isPartner ? 'You’re ready' : 'Ready'} to receive payouts.
      </P>

      <Button $w="100%" $selected onClick={() => setIsOpen(false)}>
        Done
      </Button>
    </ModalPortal>
  );
};
